import React, { Fragment, useContext, useEffect, useState } from "react";
import GoBackBtn from "../../components/buttons/GoBackBtn";
import { Container, Row, Col, Form, Alert, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import ClassCard from "../../components/classes/ClassCard";
import { postMethod } from "../../requests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faExclamationCircle, faExclamationTriangle, faSpinner } from "@fortawesome/free-solid-svg-icons";
import "./schedules.css";
import { daysLater } from "../../commonData";
import moment from "moment";
import DateTimeSelector from "../../components/DateTimeSelector";
import ChoosePass from "../../components/passes/ChoosePass";
import PaymentForPassModal from "../../components/modals/PaymentForPassModal";

const SignUpForWaitingList = () => {
    const { t } = useTranslation();
    const { checkServerData, changeView, setAlerts, showView } = useContext(BasicContext);
    const [blockForm, setBlockForm] = useState(false);
    const [formChanged, setFormChanged] = useState(false);
    const [loading, setLoading] = useState(true);
    const [selectedPass, setSelectedPass] = useState(null);
    const [alertValidation, setAlertValidation] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [showPaymentForPassModal, setShowPaymentForPassModal] = useState(null);
    const [reloadActivePasses, setReloadActivePasses] = useState(false);

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        //if (!selectedPass && !blockForm) errors.push(t("error.noCheckedPass"));

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t("info.signingUpForClass") }]);
            setBlockForm(true);
            signUpForWaitingList();
        }
    };

    const signUpForWaitingList = async () => {
        const res = await postMethod("/signup-for-waiting-list", {
            classID: showView.params.class.class_id,
            upID: selectedPass,
            waitListDate: !selectedDate ? moment(showView.params.class.class_signup_end_time).format("YYYY-MM-DD HH:mm") : selectedDate,
        });
        if (checkServerData(res)) {
            setAlerts([
                res.data.code === "noFreeSlots" || res.data.code === "cannotSignupYet" || res.data.code === "cannotSignup"
                    ? { variant: "warning", message: t(`warning.${res.data.code}`) }
                    : { variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "signupForClass" },
            ]);
            changeView({ nav: "schedule", params: { moduleName: "APP" } });
        } else setBlockForm(false);
    };

    const checkIfClassIsStillValid = async () => {
        const res = await postMethod("/class-validation", { classID: showView.params.class.class_id, waitingList: true });
        if (checkServerData(res)) {
            if (!res.data.status) setAlertValidation({ variant: res.data.variant, message: t(`${res.data.variant}.${res.data.message}`) });
        }
        setLoading(false);
    };

    useEffect(() => {
        checkIfClassIsStillValid();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <GoBackBtn />
            <Form onSubmit={checkValidation} autoComplete="off">
                <Container fluid="lg">
                    <Row>
                        <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                            <h1 className="h5 d-inline-block m-0 pt-2">{t("schedule.signUpForWaitingList")}</h1>
                        </Col>
                        <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                            <input type="text" name="prevent-autofill" id="prevent-autofill" style={{ display: "none" }} autoComplete="off" />
                            <Row>
                                <Col xs={12} lg={6} xxl={5}>
                                    <ClassCard c={showView.params.class} />
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12}>
                            <Alert variant="info" className="alert-small">
                                <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                                {t("info.signUpForWaitingList")}
                            </Alert>
                        </Col>

                        <DateTimeSelector
                            setSelectedDate={setSelectedDate}
                            startDate={daysLater(showView.params.class.class_signup_end_time, -1) > new Date() ? moment(daysLater(showView.params.class.class_signup_end_time, -1)) : moment()}
                            endDate={moment(showView.params.class.class_signup_end_time)}
                        />
                        {loading ? (
                            <Col>
                                <p className="h6">
                                    {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                                </p>
                            </Col>
                        ) : alertValidation ? (
                            <Alert variant={alertValidation.variant}>
                                <FontAwesomeIcon
                                    icon={alertValidation.variant === "danger" ? faExclamationCircle : alertValidation.variant === "warning" ? faExclamationTriangle : faCircleInfo}
                                    className="me-2"
                                />
                                {alertValidation.message}
                            </Alert>
                        ) : (
                            <ChoosePass
                                selectedPass={selectedPass}
                                setSelectedPass={setSelectedPass}
                                setFormChanged={setFormChanged}
                                blockForm={blockForm}
                                classID={showView.params.class.class_id}
                                onShowPaymentForPassModal={setShowPaymentForPassModal}
                                reloadActivePasses={reloadActivePasses}
                                setReloadActivePasses={setReloadActivePasses}
                            />
                        )}
                    </Row>
                    <Row className="sticky-bottom bg-light-primary">
                        <Col xs={6}>
                            <Button variant="primary" className="px-4 mt-4 mb-4" type="submit" disabled={blockForm || !formChanged}>
                                {t("signup")}
                            </Button>
                        </Col>
                        <Col xs={6} className="text-end">
                            <Button variant="outline-secondary" className="px-4 mt-4 mb-4" onClick={() => changeView({ nav: "schedule", params: { moduleName: "APP" } })}>
                                {t("cancel")}
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Form>

            {showPaymentForPassModal && (
                <PaymentForPassModal
                    pass={showPaymentForPassModal}
                    onClose={() => setShowPaymentForPassModal(false)}
                    onProceed={() => {
                        setShowPaymentForPassModal(false);
                        setReloadActivePasses(true);
                    }}
                    signUpForClass
                />
            )}
        </Fragment>
    );
};

export default SignUpForWaitingList;
